import React from 'react';
import * as PropTypes from 'prop-types';

import './CareersPage.scss';
import { classNamer, classes } from '../../lib/utils';
import CareerList from './CareerList';
import PageLayoutBroad from '../layout/PageLayoutBroad';

import {
  FoodIcon,
  MoneyIcon,
  CityIcon,
  RocketIcon,
  AwardIcon,
  TeamIcon,
} from '../../../static/icons/svg_icons';
import { Button, BUTTON_VARIANTS } from '../widgets/Button';
import i18n from '../../translations/i18n';

const cn = classNamer('CareersPage');

class CareersPage extends React.PureComponent {
  careersRef = React.createRef();

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  scrollToCareers = () => {
    window.scrollTo({
      top: window.pageYOffset + this.careersRef.current.getBoundingClientRect().top,
      behavior: 'smooth',
    });
  };

  renderMain() {
    return (
      <section className={classes(cn('main'), cn('section'))}>
        <div className="container hasDarkBackground wow animated fadeInRightSmall">
          <div className="col-12 text-block wow animated fadeInLeftSmall" data-wow-delay=".6s">
            <p>{i18n.careersAtXcalibra}</p>
            <h1 className={classes('title')}>{i18n.careersPageTitle}</h1>
            <p>{i18n.careersPageDescription}</p>
          </div>
        </div>
      </section>
    );
  }

  renderCareers() {
    return (
      <section
        ref={this.careersRef}
        className={classes(cn('careers'), cn('section'), 'wow animated fadeInUpSmall')}
      >
        <div className="container">
          <h2>{i18n.careersCareersSectionTitle}</h2>
          <CareerList careers={this.props.careers} />
        </div>
      </section>
    );
  }

  renderExchange() {
    return (
      <section className={classes(cn('exchange'), cn('section'), 'wow animated fadeInRightSmall')}>
        <div className="container hasDarkBackground ">
          <div className="col-12 wow animated fadeInLeftSmall" data-wow-delay=".6s">
            <h2>{i18n.careersExchangeSectionTitle}</h2>
            <p>{i18n.careersExchangeSectionTextOne}</p>
            <p>{i18n.careersExchangeSectionTextTwo}</p>
            <p>{i18n.careersExchangeSectionTextThree}</p>
          </div>
        </div>
      </section>
    );
  }

  renderBenefits() {
    return (
      <section className={classes(cn('benefits'), cn('section'))}>
        <div className="container wow animated fadeInUpSmall">
          <h2>{i18n.careersBenefitsSectionTitle}</h2>
          <p className="section-description">{i18n.careersBenefitsSectionDescription}</p>
          <div className={'items'}>
            <div className={'item wow animated fadeInUpSmall'} data-wow-delay=".2s">
              <MoneyIcon />
              <h3>{i18n.careersBenefitsSectionBenefitTitleOne}</h3>
              <h4>{i18n.careersBenefitsSectionBenefitTextOne}</h4>
            </div>
            <div className={'item wow animated fadeInUpSmall'} data-wow-delay=".4s">
              <TeamIcon />
              <h3>{i18n.careersBenefitsSectionBenefitTitleTwo}</h3>
              <h4>{i18n.careersBenefitsSectionBenefitTextTwo}</h4>
            </div>
            <div className={'item wow animated fadeInUpSmall'} data-wow-delay=".6s">
              <FoodIcon />
              <h3>{i18n.careersBenefitsSectionBenefitTitleThree}</h3>
              <h4>{i18n.careersBenefitsSectionBenefitTextThree}</h4>
            </div>
            <div className={'item wow animated fadeInUpSmall'} data-wow-delay=".8s">
              <RocketIcon />
              <h3>{i18n.careersBenefitsSectionBenefitTitleFour}</h3>
              <h4>{i18n.careersBenefitsSectionBenefitTextFour}</h4>
            </div>
            <div className={'item wow animated fadeInUpSmall'} data-wow-delay="1s">
              <CityIcon />
              <h3>{i18n.careersBenefitsSectionBenefitTitleFive}</h3>
              <h4>{i18n.careersBenefitsSectionBenefitTextFive}</h4>
            </div>

            <div className={'item wow animated fadeInUpSmall'} data-wow-delay="1s">
              <AwardIcon />
              <h3>{i18n.careersBenefitsSectionBenefitTitleSix}</h3>
              <h4>{i18n.careersBenefitsSectionBenefitTextSix}</h4>
            </div>
          </div>
        </div>
      </section>
    );
  }

  renderJoinUs() {
    return (
      <section className={classes(cn('join-us'), cn('section'))}>
        <div className="container wow animated  zoomIn">
          <h2>{i18n.careersJoinUsSectionTitle}</h2>
          <Button onClick={this.scrollToCareers} variant={BUTTON_VARIANTS.primary}>
            {i18n.careersJoinUsSectionButton}
          </Button>
        </div>
      </section>
    );
  }

  render() {
    const { careers, ...passProps } = this.props;

    return (
      <PageLayoutBroad className={cn()} {...passProps}>
        {this.renderMain()}
        {this.renderCareers()}
        {this.renderExchange()}
        {this.renderBenefits()}
        {this.renderJoinUs()}
      </PageLayoutBroad>
    );
  }
}

CareersPage.propTypes = {
  careers: PropTypes.array,
};

export default CareersPage;
